<template>
  <div class="student-container">
    <el-input
      style="width: 200px; margin-right: 20px"
      v-model="search.name"
      placeholder="姓名"
      size="small"
    ></el-input>
    <el-input
      style="width: 200px; margin-right: 20px"
      v-model="search.stuId"
      placeholder="學生編號"
      size="small"
    ></el-input>
    <el-input
      style="width: 200px; margin-right: 20px"
      v-model="search.room"
      placeholder="房間編號"
      size="small"
    ></el-input>
    <el-select
      v-model="search.gender"
      size="small"
      style="width: 100px; margin-right: 20px"
      placeholder="性別"
      clearable
    >
      <el-option label="F" :value="'F'" />
      <el-option label="M" :value="'M'" />
    </el-select>
    <el-input
      style="width: 200px; margin-right: 20px"
      v-model="search.mobile"
      placeholder="聯絡電話"
      size="small"
    ></el-input>
    <el-select
      v-model="search.studentType"
      size="small"
      style="width: 220px; margin-right: 20px"
      placeholder="學生類型"
      clearable
      multiple
      collapse-tags
    >
      <el-option label="Scholarship Recipient" :value="1" />
      <el-option label="Trainee" :value="2" />
      <el-option label="Others" :value="3" />
    </el-select>
    <el-select
      v-model="search.haveHostel"
      size="small"
      style="width: 150px; margin-right: 20px"
      placeholder="是否分配宿舍"
      clearable
    >
      <el-option label="是" :value="1" />
      <el-option label="否" :value="0" />
    </el-select>
    <el-button type="primary" @click="reset" size="small">重置</el-button>
    <el-button
      type="success"
      icon="el-icon-search"
      @click="getList"
      size="small"
      >查詢</el-button
    >
    <el-row>
      <el-button
        icon="el-icon-refresh"
        type="success"
        @click="syncDPSI"
        size="small"
        style="margin-top: 1rem; width: 120px"
        :loading="loading"
        >DPSI數據拉取</el-button
      >
    </el-row>
    <el-table :data="tableData" stripe style="width: 100%" height="650">
      <el-table-column label="學校帳號" prop="Account.Value" width="200" />
      <el-table-column label="學生編號" prop="StudentId.Value" />
      <el-table-column label="英文名">
        <template slot-scope="scope">
          {{ scope.row.FullName.Value + "(" + scope.row.OtherName.Value + ")" }}
        </template>
      </el-table-column>
      <el-table-column label="中文名" prop="ChineseName.Value" />
      <el-table-column label="性別" prop="Gender.Value" width="50" />
      <el-table-column label="聯絡電話" prop="TelMobile.Value" />
      <el-table-column label="宿舍房間" prop="HostelRoom.Value" />
      <el-table-column label="床位" prop="HostelBed.Value" width="50" />
      <el-table-column label="操作" min-width="300">
        <template slot-scope="scope">
          <el-button
            size="small"
            @click="refresh(scope.row)"
            type="success"
            icon="el-icon-refresh"
          >
          </el-button>
          <el-button
            size="small"
            @click="handleEdit(scope.$index, scope.row)"
            type="primary"
          >
            詳情
          </el-button>
          <el-button size="small" type="primary" @click="adjust(scope.row)"
            >宿舍調整</el-button
          >
          <el-button size="small" type="warning" @click="debit(scope.row)"
            >補單</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="text-align: center; margin-top: 20px"
      background
      :total="total"
      :current-page.sync="currentPage"
      @size-change="handleSizeChange"
      @current-change="getList"
      :page-sizes="[10, 50, 200, 1000]"
      :page-size="size"
      layout="total, sizes, prev, pager, next"
    >
    </el-pagination>
    <info ref="infoModal" @handleSuccess="updList"></info>
    <adjust-modal ref="adjustModal" @adjustSuccess="getList"></adjust-modal>
  </div>
</template>

<script>
import Info from "./modules/StudentInfo";
import AdjustModal from "./modules/AdjustModal";
import {
  getList,
  syncDPSI,
  debit,
  syncDPSISingle,
} from "@/api/document/student";
import { delEmpty } from "@/utils/utils";
export default {
  components: {
    Info,
    AdjustModal,
  },
  data() {
    return {
      loading: false,
      size: 10,
      currentPage: 1,
      total: 100,
      deleteItem: "",
      deleteIndex: "",
      tableData: [],
      search: {
        name: "",
        stuId: "",
        gender: "",
        mobile: "",
        room: "",
        haveHostel: null,
        studentType: [],
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    handleEdit(index, row) {
      this.$refs.infoModal.edit(index, row);
    },
    adjust(row) {
      this.$refs.adjustModal.edit(row);
    },
    reset() {
      this.search = {
        name: "",
        stuId: "",
        gender: "",
        mobile: "",
        room: "",
        haveHostel: null,
        studentType: [],
      };
    },
    getList() {
      getList(
        delEmpty({
          Name: this.search.name,
          StudentID: this.search.stuId,
          Gender: this.search.gender,
          Mobile: this.search.mobile,
          HaveHostel: this.search.haveHostel,
          StudentType: this.search.studentType.join(","),
          RoomIndex: this.search.room,
          PageIndex: this.currentPage,
          PageSize: this.size,
        })
      ).then((res) => {
        if (res.data != undefined || res.data != null) {
          this.total = res.data.Total;
          this.tableData = res.data.Items;
        }
      });
    },
    updList(index, row) {
      this.tableData.splice(index, 1, row);
    },
    syncDPSI() {
      this.loading = true;
      syncDPSI()
        .then(() => {
          this.getList();
          this.loading = false;
        })
        .catch(() => {
          this.getList();
          this.loading = false;
        });
    },
    handleSizeChange(val) {
      this.size = val;
      this.getList();
    },
    debit(row) {
      this.$confirm(this.$t("app.confirmDebit")).then(() => {
        this.loading = true;
        debit({
          StudentCode: row.StudentId.Value
            ? row.StudentId.Value
            : row.ApplicationCode.Value,
        })
          .then(() => {
            this.$message({
              message: this.$t("app.opeSuccess"),
              type: "success",
            });
            this.getList();
          })
          .catch(() => {
            this.loading = false;
          });
      });
    },
    refresh(row) {
      this.loading = true;
      syncDPSISingle({
        StudentCode: row.StudentId.Value
          ? row.StudentId.Value
          : row.ApplicationCode.Value,
      })
        .then(() => {
          this.getList();
          this.loading = false;
        })
        .catch(() => {
          this.getList();
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.student-container {
  background-color: #fff;
  padding: 15px;
  border: solid 1px #ccc;
}
</style>
